import { ReactNode } from 'react';

import { Box } from '@mui/material';

import { Block } from 'components/page';
import { DreFormTitle } from 'pages/financeiro/dre/components/';

interface DreFormGroupProps {
    label: string;
    id: string;
    children: ReactNode;
}

export function DreFormGroup({ id, label, children }: DreFormGroupProps) {
    return (
        <Block sx={{ p: 0, m: 0 }} id={id}>
            <DreFormTitle label={label} />

            <Box
                sx={{
                    p: 2,
                    gap: 2,
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {children}
            </Box>
        </Block>
    );
}
